var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GSwitch',_vm._g(_vm._b({tag:"component",staticClass:"passport-switch",scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(_,name){return {key:name,fn:function(slotData){return [_vm._t(name,null,null,slotData)]}}})],null,true)},'component',{ ..._vm.$attrs, ..._vm.$props },false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }